module.exports = __webpack_public_path__ + "static/media/android-chrome-192x192.eb8a62d2.png";